import { ValidatorFn, AbstractControl, FormGroup, FormControl, ValidationErrors, FormArray } from '@angular/forms';

export class CustomValidators {

  static requiredObject(acceptNullableObj: boolean = false): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let isValid = false;
      if (acceptNullableObj) {
        isValid = control.value === null || (typeof control.value === 'string' && control.value.length === 0) || typeof control.value === 'object';
      } else {
          isValid = control.value != null && typeof control.value === 'object';
      }

      if (isValid) {
        return null; // valid
      } else {
        return { requiredObject: true };
      }

    };
  }


  static requiredNotEmptyList(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {

        if (control.value !== null && control.value instanceof Array && control.value.length > 0) {
          return null; // valid
        } else {
          return { required: true };
        }
    };
  }


  static validateAllFormFields(formGroup: FormGroup/*, index = 0*/) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      // if (control instanceof FormControl) {
      //   console.log('FormControl - ' + index, field);
      //   control.markAsTouched({ onlySelf: true });        
      // } else if (control instanceof FormGroup) {
      //   console.log('FormGroup - ' + index, field);
      //   CustomValidators.validateAllFormFields(control, index+1);
      // }
      // else if (control instanceof FormArray) {
      //   console.log('Unknown - ' + index, control);
      //   for(const fg of (control as FormArray).controls){          
      //     CustomValidators.validateAllFormFields(fg as FormGroup, index+1);
      //   }
      // }

      switch(control.constructor){
        case FormControl:
          control.markAsTouched({ onlySelf: true });   
          break;
        case FormGroup:
          CustomValidators.validateAllFormFields(control as FormGroup);
          break;
        case FormArray:
          for(const childFG of (control as FormArray).controls){          
            CustomValidators.validateAllFormFields(childFG as FormGroup);
          }
          break;
        default:
          console.error('Undetermined type of control to validate in "validateAllFormFields" function.')
      }

    });
  }

}
